declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

const MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;
const PLATFORM = import.meta.env.VITE_PLATFORM_NAME ?? 'zero';
const ENVIRONMENT =
  import.meta.env.VITE_GA_ENV ?? (import.meta.env.DEV ? 'local' : 'production');

let initialized = false;

function isEnabled(): boolean {
  return Boolean(MEASUREMENT_ID && window.gtag);
}

function baseEventParams(): Record<string, string> {
  return {
    platform: PLATFORM,
    environment: ENVIRONMENT,
  };
}

export function initAnalytics(): void {
  if (!MEASUREMENT_ID || initialized) {
    return;
  }

  initialized = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer!.push(args);
  };

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.gtag('js', new Date());
  window.gtag('config', MEASUREMENT_ID, {
    send_page_view: true,
    ...(ENVIRONMENT === 'local' ? { debug_mode: true } : {}),
  });
}

export function setAnalyticsUser(userId: string): void {
  if (!MEASUREMENT_ID || !window.gtag) {
    return;
  }
  window.gtag('config', MEASUREMENT_ID, { user_id: userId });
}

export function clearAnalyticsUser(): void {
  if (!MEASUREMENT_ID || !window.gtag) {
    return;
  }
  window.gtag('config', MEASUREMENT_ID, { user_id: null });
}

export function trackLogin(): void {
  if (!isEnabled()) {
    return;
  }
  window.gtag!('event', 'login', {
    method: 'credentials',
    ...baseEventParams(),
  });
}

export function trackEvent(name: string, params?: Record<string, string>): void {
  if (!isEnabled()) {
    return;
  }
  window.gtag!('event', name, {
    ...baseEventParams(),
    ...params,
  });
}
